import { BaseConfig } from '../ServiceConfig';

export const IAMConfigurationType =
  'type.googleapis.com/terra.v1.IamServiceConfigData';

export interface IAMAuthorizer {
  code: AuthorizerCode;
  name: string;
  config: {
    appId?: string;
    appSecret?: string;
    isAllowResetPassword?: string;
    isIamResetPasswordEnabled?: string;
  };
  isEnabled: boolean;
}

export enum AuthorizerCode {
  Google = 'google',
  Facebook = 'facebook',
  Apple = 'apple',
  Password = 'password',
  Passwordless = 'passwordless',
  IBanking = 'ibanking',
  Custom = 'custom',
}

export interface IAMConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.IamServiceConfigData';
  oauthUrl: string;
  identityUrl: string;
  clientId: string;
  scope: string;
  authorizers: IAMAuthorizer[];
  uiConfig?: LoginUIConfig;
}

export const IAMConfigurationFields: (keyof IAMConfiguration)[] = [
  'clientId',
  'identityUrl',
  'oauthUrl',
  'scope',
];

export const BlankIAMConfiguration: IAMConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.IamServiceConfigData',
} as IAMConfiguration;

export interface LoginUIConfig {
  logoUrl?: string;
  policy?: LoginPolicyConfig;
  titles?: LoginTitleItem[];
}

export interface LoginPolicyConfig {
  isEnabled: boolean;
  isChecked: boolean;
  languages: LoginPolicyItem[];
}

export interface LoginPolicyItem extends MultiLanguagesSupportable {
  content: string;
  links: LoginPolicyLinkItem[];
}

export interface LoginPolicyLinkItem {
  token: string;
  url: string;
}

export interface LoginTitleItem extends MultiLanguagesSupportable {
  content: string;
}

export interface MultiLanguagesSupportable {
  code: string;
}
